import Moment from "moment";
import Pagination from "../pagination/pagination";
import { useState } from "react";
import GeneralPopup from "../shared/GeneralPopup";
import AddTransaction from "../components/AddTransaction";
import { useRef, useEffect, Fragment } from "react";
import { auth } from "../services/auth";
import { MinusCircleIcon, PlusCircleIcon } from "@heroicons/react/24/outline";
import Loader from "../shared/Loader";
import { Helmet } from "react-helmet";
import {
  getTransactionAdmin,
  getTransaction,
  updateStatus,
  getById,
  getOrderStatuses,
} from "../services/billing";
import styles from "../css/billing.module.css";

export default function Billing() {
  const ref = useRef();
  let PageSize = 15;
  let data = [];
  let totalRecords = 0;

  const [currentPage, setCurrentPage] = useState(1);
  const [post, setPost] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [showPopup, setPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [billingStatuses, setbillingStatuses] = useState({});
  const [selectedStatus, setSelectedStatus] = useState();
  const [userData, setUserData] = useState();
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [isLoadingStatus, setIsLoadingStatus] = useState(false);
  const isAdmin = auth().isAdmin();
  const user = auth().getUser();
  const token = auth().getToken();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  useEffect(() => {
    if (isAdmin) {
      getTransactionAdmin(currentPage, PageSize, config).then((response) => {
        setPost(response.data);
      });
    } else {
      getTransaction(user, currentPage, PageSize, config).then((response) => {
        setPost(response.data);
      });
    }
  }, [currentPage, refresh]);

  if (post != null) {
    data = post?.data;
  }

  if (post?.totalRecords != null) {
    totalRecords = post?.totalRecords;
  }

  const togglePopup = (value) => {
    setPopup(!showPopup);
    setSelectedRow(data[value]);
  };

  const setRefreshTwo = (value) => {
    setRefresh(!refresh);
  };

  useEffect(() => {
    setIsLoading(true);
    if (isAdmin) {
      getOrderStatuses(config)
        .then((response) => {
          setbillingStatuses(response.data);
        })
        .catch((error) => {
          setHasError(true);
          setError("Invalid fetching, please try again");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
    getById(user, config)
      .then((response) => {
        setUserData(response.data);
      })
      .catch((error) => {
        setHasError(true);
        setError("Invalid fetching, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [isAdmin]);

  const handleChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const saveStatus = (value) => {
    setIsLoadingStatus(true);
    updateStatus(value, selectedStatus, config)
      .then((response) => {
        setPopup(!showPopup);
        setRefresh(!refresh);
        setSuccess(true);
      })
      .catch((error) => {
        setHasError(true);
        setError(error.message);
        setSuccess(false);
      })
      .finally(() => {
        setIsLoadingStatus(false);
      });
  };
  const backgroundStatusColor = (status) => {
    switch (status) {
      case 1: // Pending
        return "bg-gray-400";
      case 2: //Awaiting Payment
        return "bg-red-400";
      case 3: //In Progress
        return "bg-pink-350";
      case 4: // Canceled
        return "bg-gray-400";
      case 5: // Declined
        return "bg-gray-400";
      case 6: // Refunded
        return "bg-green-450";
      case 7: // Completed
        return "bg-green-450";
      case 8: // Delayed
        return "bg-pink-350";
      case 9: // Partial
        return "bg-green-450";
      case 10: // Processing
        return "bg-pink-350";
      default:
        return "text-black";
    }
  };
  return (
    <section className="flex flex-col my-20 px-3 md:px-5 lg:px-5">
      <Helmet>
        <title>Dailysocialboost | Billing</title>
      </Helmet>
      <h2 className="text-xl font-bold my-5">Billing</h2>
      <div
        className={`flex flex-col md:flex-row lg:flex-row gap-5 justify-between my-5 ${styles.billingDiv}`}
      >
        <button
          className="my-5 px-20 py-3 uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
          onClick={() => ref.current.togglePopupTrans()}
        >
          Add Funds
        </button>
        <div className="flex flex-row text-center self-center px-10 py-3 rounded-3xl -100 border-2 border-purple-300 bg-round-xl">
          <label className="font-semibold">Current Deposit: </label>
          <div className="mx-3">${userData?.deposit}</div>
        </div>
      </div>
      <AddTransaction ref={ref} refresh={setRefreshTwo} />
      <div className={`${styles.billingDiv}`}>
        <h2 className="text-xl font-bold my-5">Transaction history</h2>
        <div
          className={`flex flex-col ${
            isLoading ? "justify-center" : hasError ? "justify-center" : "justify-center"
          }`}
        >
          {isLoading ? (
            <div className="my-5 mx-20">
              {" "}
              <Loader styles={"w-12 h-12"}></Loader>{" "}
            </div>
          ) : hasError ? (
            <div
              key={Math.random()}
              className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
              role="alert"
            >
              <svg
                aria-hidden="true"
                className="flex-shrink-0 inline w-5 h-5 mr-3"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                ></path>
              </svg>
              <div>
                <span className="font-medium">Error!</span> Failed loading, please try again!
              </div>
            </div>
          ) : null}
        </div>
        {data.length > 0 ? (
          <div className="grid grid-cols-12 gap-1  overflow-x-auto  sm:overflow-x-none md:overflow-x-none lg:overflow-x-none scrollbar lg:gap-2 ">
            <div className="font-semibold flex flex-row items-center col-span-2">Id</div>
            <div className="font-semibold flex flex-row items-center col-span-2">Desc.</div>
            <div className="font-semibold flex flex-row items-center col-span-2">Status</div>
            {isAdmin ? (
              <div className="font-semibold flex flex-row items-center col-span-2">User</div>
            ) : null}
            <div className="font-semibold flex flex-row items-center col-span-1">Created</div>
            <div className="font-semibold flex flex-row items-center col-span-1 ">Trans. Type</div>
            <div className="font-semibold flex flex-row items-center col-span-1">Amount</div>
            <div className="font-semibold flex flex-row items-center col-span-1">Preview</div>
            <div className="col-span-12">
              <hr />
            </div>
            {data?.map((item, idx) => (
              <Fragment key={item?.id}>
                <div className="grid grid-cols-12  col-span-12 gap-2 lg:gap-2 hover:bg-pink-100 transition-all">
                  <div className="flex flex-row items-center col-span-2">#{item.id}</div>
                  <div className="flex flex-row items-center col-span-2 truncate ...">
                    {item.description}
                  </div>
                  <div
                    className={`flex flex-row items-center col-span-2  text-white text-center place-content-center self-center px-2 rounded-3xl ${backgroundStatusColor(
                      item.orderStatus.id
                    )}`}
                  >
                    {item?.orderStatus.name}
                  </div>
                  {isAdmin ? (
                    <div className="flex flex-row items-center col-span-2 break-all">
                      {item?.user.userName}
                    </div>
                  ) : null}
                  <div className="flex flex-row items-center col-span-1">
                    {Moment(item.created).format("YYYY-MM-DD")}
                  </div>
                  <div className="flex flex-row items-center col-span-1 ">
                    {" "}
                    {item?.transactionTypeId === 2 ? (
                      <MinusCircleIcon className="mx-3 h-6 w-6 text-red-500" />
                    ) : (
                      <PlusCircleIcon className="mx-3 h-6 w-6 text-green-500" />
                    )}
                  </div>
                  <div className="flex flex-row items-center col-span-1">
                    {item?.transactionTypeId === 2 ? -item.amount : item.amount} $
                  </div>
                  <div className="flex flex-row items-center col-span-1">
                    <button
                      className="font-semibold"
                      id={idx}
                      onClick={(e) => togglePopup(e.target.id)}
                    >
                      Preview
                    </button>
                  </div>
                </div>
              </Fragment>
            ))}
          </div>
        ) : !isLoading ? (
          <>No orders yet!</>
        ) : null}
      </div>
      <div className="flex flex-row mt-12">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={totalRecords}
          pageSize={PageSize}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
      {showPopup ? (
        <GeneralPopup title="Order Details" closePopup={togglePopup}>
          <div className="flex flex-col md:flex-col lg:flex-row justify-center align-center lg:justify-around">
            <div className="flex flex-col items-center">
              <div>
                <p>
                  <label className="uppercase font-semibold" htmlFor="transactionNo">
                    Transaction Id{" "}
                  </label>
                </p>
                <input
                  className={`${styles.billingInput}`}
                  disabled
                  type="text"
                  value={selectedRow?.id || ""}
                  name="transactionNo"
                  id="transactionNo"
                  required
                />
              </div>
              <div>
                <p>
                  <label className="uppercase font-semibold" htmlFor="orderStatusName">
                    Order Status
                  </label>
                </p>
                <input
                  className={`${styles.billingInput}`}
                  disabled
                  type="text"
                  value={selectedRow?.orderStatus?.name || ""}
                  name="orderStatusName"
                  id="orderStatusName"
                  required
                />
              </div>
              <div>
                <p>
                  <label className="uppercase font-semibold" htmlFor="description">
                    Description
                  </label>
                </p>
                <input
                  className={`${styles.billingInput}`}
                  disabled
                  type="text"
                  value={selectedRow?.description || ""}
                  name="description"
                  id="description"
                  required
                />
              </div>

              <div>
                <p>
                  <label className="uppercase font-semibold" htmlFor="created">
                    Created
                  </label>
                </p>
                <input
                  className={`${styles.billingInput}`}
                  disabled
                  type="text"
                  value={Moment(selectedRow?.created).format("YYYY-MM-DD HH:mm") || ""}
                  name="created"
                  id="created"
                  required
                />
              </div>
              <div>
                <p>
                  <label className="uppercase font-semibold" htmlFor="userName">
                    User Name
                  </label>
                </p>
                <input
                  className={`${styles.billingInput}`}
                  disabled
                  type="text"
                  value={selectedRow?.user?.email}
                  name="userName"
                  id="userName"
                  required
                />
              </div>
            </div>
            <div className="flex flex-col items-center">
              <div>
                <p>
                  <label className="uppercase font-semibold" htmlFor="amount">
                    Total
                  </label>
                </p>
                <input
                  className={`${styles.billingInput}`}
                  disabled
                  type="text"
                  value={selectedRow?.amount || ""}
                  name="amount"
                  id="amount"
                  required
                />
              </div>
              {/* <div>
									<p>
										<label className="uppercase font-semibold" htmlFor="paymentPaymentComment">Payment Comment</label>
									</p>
									<input className={`${styles.billingInput}`} disabled type="text" value={selectedRow?.payment?.paymentComment || ""} name="paymentPaymentComment" id="paymentPaymentComment" required />
								</div> */}
              <div>
                <p>
                  <label className="uppercase font-semibold" htmlFor="payed">
                    Payed
                  </label>
                </p>
                <input
                  className={`${styles.billingInput}`}
                  disabled
                  type="text"
                  value={
                    selectedRow?.payment?.paymentTime != null
                      ? Moment(selectedRow?.payment?.paymentTime).format("YYYY-MM-DD HH:mm")
                      : "/"
                  }
                  name="payed"
                  id="payed"
                  required
                />
              </div>
              <div>
                <p>
                  <label className="uppercase font-semibold" htmlFor="coinbase">
                    Service
                  </label>
                </p>
                <input
                  className={`${styles.billingInput}`}
                  disabled
                  type="text"
                  value={selectedRow?.payment?.coinbase != null ? "Coinbase" : "Funds"}
                  name="service"
                  id="service"
                  required
                />
              </div>
              <div>
                <p>
                  <label className="uppercase font-semibold" htmlFor="hostedUrl">
                    URL
                  </label>
                </p>
                <input
                  className={`${styles.billingInput}`}
                  disabled
                  type="text"
                  value={selectedRow?.payment?.coinbase?.hostedUrl || ""}
                  name="hostedUrl"
                  id="hostedUrl"
                  required
                />
              </div>
              <div>
                <p>
                  <label className="uppercase font-semibold" htmlFor="transactionNo">
                    Transaction No{" "}
                  </label>
                </p>
                <input
                  className={`${styles.billingInput}`}
                  disabled
                  type="text"
                  value={selectedRow?.transactionNo || ""}
                  name="transactionNo"
                  id="transactionNo"
                  required
                />
              </div>
              {isAdmin ? (
                <div className="my-10 gap-2 flex flex-col lg:gap-0 items-center lg:flex-row">
                  <label className="px-3 font-semibold">Change Status: </label>
                  <select
                    value={selectedRow?.orderStatus?.id}
                    className="border w-48 px-2 py-1 rounded-2xl bg-white border-pink-350"
                    onChange={handleChange}
                  >
                    {billingStatuses?.map((stat, idx) => (
                      <option value={stat?.id}>{stat?.description}</option>
                    ))}{" "}
                  </select>
                  <button
                    className={`${styles.billingSaveBtn}`}
                    id={selectedRow?.transactionNo}
                    onClick={(e) => saveStatus(e.target.id)}
                  >
                    Save
                  </button>
                </div>
              ) : null}
              <div>
                <div
                  className={`flex flex-col ${
                    isLoadingStatus
                      ? "justify-center"
                      : hasError
                      ? "justify-center"
                      : "justify-center"
                  }`}
                >
                  {isLoadingStatus ? (
                    <div className="my-5 mx-20">
                      {" "}
                      <Loader styles={"w-12 h-12"}></Loader>{" "}
                    </div>
                  ) : hasError ? (
                    <div
                      key={Math.random()}
                      className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
                      role="alert"
                    >
                      <svg
                        aria-hidden="true"
                        className="flex-shrink-0 inline w-5 h-5 mr-3"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                      <div>
                        <span className="font-medium">Error!</span> {error}
                      </div>
                    </div>
                  ) : null}
                </div>
                {success ? (
                  <div
                    className="flex p-4 mb-4 text-sm text-white rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400"
                    role="alert"
                  >
                    <svg
                      aria-hidden="true"
                      className="flex-shrink-0 inline w-5 h-5 mr-3"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    <div>
                      <span className="font-medium">Success!</span> Sucessfully changed status!
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </GeneralPopup>
      ) : null}
    </section>
  );
}
